export default __webpack_public_path__ + "static/media/chest2.6f93382b.png";